export default __webpack_public_path__ + "static/media/Level21.5309739a.svg";